var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.overlay,"absolute":_vm.Absolute,"opacity":_vm.Opacity}},[_c('div',{staticClass:"text-center h3"},[_vm._v(" "+_vm._s(_vm.Text)+" ")]),_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.Size,"width":3}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }